export function getBorder(color: string, thickness = 1, style = 'solid'): string {
  return `${thickness}px ${style} ${color}`;
}
